import React from 'react';
import { cn } from '../../utils/cn';

const Input = React.forwardRef(({ 
  className, 
  type = 'text', 
  ...props 
}, ref) => {
  return (
    <input
      type={type}
      ref={ref}
      className={cn('reddit-input', className)}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export default Input;